














import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';
import DecimalComponent from '@/components/Controls/DecimalComponent.vue';
import TimestampComponent from '@/components/Controls/TimestampComponent.vue';
import RelationComponent from '@/components/Controls/RelationComponent.vue';
import IntegerComponent from '@/components/Controls/IntegerComponent.vue';
import StringComponent from '@/components/Controls/StringComponent.vue';
import TimeComponent from '@/components/Controls/TimeComponent.vue';
import EnumComponent from '@/components/Controls/EnumComponent.vue';
import ColorComponent from '@/components/Controls/ColorComponent.vue';

@Component({
  components: {
    DecimalComponent,
    TimestampComponent,
    RelationComponent,
    IntegerComponent,
    StringComponent,
    TimeComponent,
    EnumComponent,
    ColorComponent
  }
})
export default class MultiComponent extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) label!: string;
  @Prop({ type: String }) type!: string;
  @Prop({ type: Object }) target!: any;
  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: Object }) schema!: any;

  localValue: any = null

  get componentName() {
    const type = this.type.charAt(0).toUpperCase() + this.type.slice(1);
    return type + 'Component'
  }
  get fieldSchema() {
    return this.schema ? this.schema.fields.filter((item: any) => {
      return item.code == this.target.field_name
    })[0] : [];
  }

  @Watch('value')
  onValueChange(newVal: any) {
    this.localValue = newVal;
  }

  updateValue(value: any) {
    this.onValueChange(value);

    this.$emit('input', value);
  }
  public mounted() {
    this.onValueChange(this.value);
  }
}
